import { defineComponent as _defineComponent } from 'vue'
import CInput from '@/components/shared/CInput';
import CCheckbox from '@/components/shared/CCheckbox.vue';
import CalendarColorField from './CalendarColorField.vue';
import CalendarFieldTitle from './CalendarFieldTitle.vue';
import CalendarFontField from './CalendarFontField.vue';
import { loadCustomMarker, normalizeCommaList } from './calendarUtils';
import { useCalendarConfig } from './useCalendarConfig';
import type { ImagePlaceholderElement } from '@/typings/customilyElements/canvasElements';
import type { CalendarConfig } from './types';

// Vue 2.7 SFC compiler cannot resolve imported types in defineProps

export default /*#__PURE__*/_defineComponent({
  __name: 'DaysProperties',
  props: {
    imageElement: null
  },
  emits: ["update-config"],
  setup(__props: any, { emit }: { emit: ({
    (e: 'update-config', config: Partial<CalendarConfig>): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    imageElement?: ImagePlaceholderElement;
};




const { config, elementKey, disabled, update } = useCalendarConfig(props, emit);

const onDayLettersChange = (value: string | number = '') => {
    const dayLetters = normalizeCommaList(String(value));
    if (dayLetters.split(',').length !== 7) return;
    update({ dayLetters });
};

const onDayFontSizeChange = async (value: string | number = 0) => {
    const dayFontSize = String(value);
    // The marker is picked in another section, so the element holds the current one, not the local copy
    const { markerType, customMarkerPath, customMarkerScale } = props.imageElement?.calendarConfig ?? {};
    if (markerType !== 'custom' || !customMarkerPath) {
        update({ dayFontSize });
        return;
    }

    try {
        // Uploaded markers are sized when built, so they are rebuilt to keep up with the day numbers
        update({ dayFontSize, ...(await loadCustomMarker(customMarkerPath, dayFontSize, customMarkerScale)) });
    } catch (error) {
        console.error('The custom marker could not be rescaled', error);
        update({ dayFontSize });
    }
};

return { __sfc: true,props, emit, config, elementKey, disabled, update, onDayLettersChange, onDayFontSizeChange, CInput, CCheckbox, CalendarColorField, CalendarFieldTitle, CalendarFontField }
}

})